import "./RecycledRecoveredLegend.scss";

const RecycledRecoveredLegend = (props: any) => {
  const { payload } = props;
  return (
    <div className="bar-legend" style={{ width: "100%" }}>
      {payload.map((entry: any, index: number) => (
        <div key={`rr-legend-${index}`} className="bar-legend-singleValue">
          <div
            className="color-box"
            style={{ backgroundColor: `${entry.color}` }}
          />
          <p>{entry.value}</p>
        </div>
      ))}
    </div>
  );
};

export default RecycledRecoveredLegend;
